function showModal() {
    var selecionado = document.querySelectorAll("[data-target='" + this.id + "']")[0]
    selecionado.classList.add('active')
    // selecionado.querySelectorAll('.youtube-video')[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*')
}

function closeModal() {
    let modal = document.querySelectorAll('.modal')
    for (var i = 0; i < modal.length; i++) {
        modal[i].classList.remove('active')
        let videos = modal[i].querySelectorAll('.youtube-video')
        for (var j = 0; j < videos.length; j++) {
            videos[j].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*')
        }
    }
}

var cards = document.querySelectorAll('.card')
cards.forEach(function (card) {
    card.addEventListener('click', showModal)
})

var close = document.getElementsByClassName('modal-close')
for (var i = 0; i < close.length; i++) {
    close[i].addEventListener('click', closeModal)
}

var init = false

function swiperMode() {
    let mobile = window.matchMedia('(min-width: 0px) and (max-width: 767px)')
    let tablet = window.matchMedia('(min-width: 768px) and (max-width: 991px)')
    let desktop = window.matchMedia('(min-width: 992px)')

    if (mobile.matches) {
        if (!init) {
            init = true
            var swiperGeral = new Swiper('.swiper-desafios-geral', {
                spaceBetween: 0,
                slidesPerView: 1.5,
                breakpoints: {
                    992: {
                        enabled: false
                    }
                }
            })

            var swiperDesafio = new Swiper('.swiper-desafios', {
                slidesPerView: 2,
                spaceBetween: 10,
                slidesOffsetAfter: 40,
                slidesOffsetBefore: 40,
                breakpoints: {
                    320: {
                        slidesPerView: 2.5,
                    },
                    375: {
                        slidesPerView: 2.4,
                    },
                    425: {
                        slidesPerView: 2.8,
                    },
                    640: {
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 0,
                        slidesOffsetAfter: 80,
                        slidesOffsetBefore: 80,
                        enabled: false,
                        width: 1215,
                    },
                }
            })
        }
    }

    else if (tablet.matches) {
        init = false
    }

    else if (desktop.matches) {
        init = false
    }
}

window.addEventListener('load', function () {
    swiperMode()
})

window.addEventListener('resize', function () {
    swiperMode()
})